import React, { useEffect, useContext, useState } from 'react';
import './consejoAcademico.scss';
import ReactMarkdown from 'react-markdown';
import TeamCarousel from  '../../../../../../Helpers/TeamCarousel'

// CONTEXT
import AboutusDepartmentsContext from '../../../../../../../contexts/pages/aboutus/departments/departmentsContext';

const ConsejoAcademico = () => {

    const aboutusDepartmentsContext = useContext(AboutusDepartmentsContext);
    const { academicBoard } = aboutusDepartmentsContext;
    const { tarjetas } = academicBoard;
    return (
        <div className="academic-container">
           
            <div className="academic-board-title">CONSEJO ACADEMICO</div>
                            <div className="academic-board-text">
                                {/* <DialogContentText> */}
                                    <ReactMarkdown>
                                        {academicBoard.descripcion}
                                    </ReactMarkdown>
                                {/* </DialogContentText> */}
                            </div>
            <TeamCarousel items={tarjetas} />
        </div>
    )
}

export default ConsejoAcademico;
